import { call, put, all, takeLatest, delay } from 'redux-saga/effects';
import jwtDecode from 'jwt-decode';
import { toast } from 'react-toastify';
import ReactGA from 'react-ga4';
import {
	apiLucree,
	apiHierarquia,
	apiComercial,
	apiLiquidacao,
	apiTransacao,
	apiGatewayPagamentos,
	apiToken,
} from '../../../services/api';

import history from '../../../services/history';
import {
	successTokenDev,
	failureTokenDev,
	successLogin,
	failureLogin,
	signOut,
} from './actions';


function handleErrorLoginGA4(error) {
	ReactGA.event({
		category: "Error_Login",
		action: `Erro: Login - ${error.response ? error.response.status : 'CORS'}`,
		label: `Erro: Login - ${error.response ? error.response.status : 'CORS'}`,
	});
}

function handleLoginSuccessGA4(data) {
	const userPgm = data.permissoes.view_pgm || false;
	ReactGA.event({
		category: `Login_${userPgm ? 'PGM' : 'MA'}`,
		action: `Login_${userPgm ? 'PGM' : 'MA'}`,
		label: `Login_${userPgm ? 'PGM' : 'MA'}`,
	});
}

function* requestLoginUser({ payload }) {
	const { body } = payload;

	try {
		if (typeof body === 'string') {
			var dadosMobile = '';
			var data = '';
			data = {
				access: body,
				refresh: body
			};
			dadosMobile = jwtDecode(body).sub;

			yield put(
				successLogin({
					...data,
					dados: dadosMobile,
				})
			);

			handleLoginSuccessGA4(dadosMobile)

			if (!dadosMobile.permissoes.view_dashboard) {
				history.push(`/client/transacoes`);
			} else if (dadosMobile.permissoes.view_dashboard) {
				history.push(`/client/dashboard`);
			} else if (
				dadosMobile.tipo_perfil.toLowerCase() === 'cliente' ||
				dadosMobile.tipo_perfil.toLowerCase() === 'operador' ||
				dadosMobile.tipo_perfil.toLowerCase() === ''
			) {
				apiGatewayPagamentos.defaults.headers.Authorization = `Basic ${dadosMobile.gateway_token}`;
				history.push(`/client/dashboard`);
			}
		} else {
			const resposta = yield call(
				apiLucree.post,
				'/authentication/api/token',
				body
			);

			const dados = jwtDecode(resposta.data.access).sub;

			yield put(
				successLogin({
					...resposta.data,
					dados,
				})
			);

			handleLoginSuccessGA4(dados)

			if (!dados.permissoes.view_dashboard) {
				history.push(`/client/transacoes`);
			} else if (dados.permissoes.view_dashboard) {
				history.push(`/client/dashboard`);
			} else if (
				dados.tipo_perfil.toLowerCase() === 'cliente' ||
				dados.tipo_perfil.toLowerCase() === 'operador' ||
				dados.tipo_perfil.toLowerCase() === ''
			) {
				apiGatewayPagamentos.defaults.headers.Authorization = `Basic ${dados.gateway_token}`;
				history.push(`/client/dashboard`);
			}
		}

		// let resposta;
		// if (body.username) {
		// 	resposta = yield call(
		// 		apiLucree.post,
		// 		'/authentication/api/token', body
		// 	);
		// }

		// let dados = '';
		// let data = '';

		// if (typeof body === 'string') {
		// 	console.log('body', body)
		// 	data = {
		// 		access: body,
		// 		refresh: body
		// 	};
		// 	dados = jwtDecode(body).sub;
		// 	yield put(
		// 		successLogin({
		// 			...data,
		// 			dados,
		// 		})
		// 	);
		// } else {
		// 	data = resposta.data;
		// 	console.log('res', data)
		// 	dados = jwtDecode(resposta.data.access).sub;
		// 	yield put(
		// 		successLogin({
		// 			...data,
		// 			dados,
		// 		})
		// 	);
		// }

		// if (!dados.permissoes.view_dashboard) {
		// 	history.push(`/client/transacoes`);
		// } else if (dados.permissoes.view_dashboard) {
		// 	history.push(`/client/dashboard`);
		// } else if (
		// 	dados.tipo_perfil.toLowerCase() === 'cliente' ||
		// 	dados.tipo_perfil.toLowerCase() === 'operador' ||
		// 	dados.tipo_perfil.toLowerCase() === ''
		// ) {
		// 	apiGatewayPagamentos.defaults.headers.Authorization = `Basic ${dados.gateway_token}`;
		// 	history.push(`/client/dashboard`);
		// }

	} catch (error) {
		yield put(
			failureLogin(error.response.data.message ? error.response.data.message : 'CORS')
		);

		toast.error(
			`Erro: ${error.response.data.message ? error.response.data.message : 'Revise seu usuário ou senha e tente novamente' }`
		);

		handleErrorLoginGA4(error)
	}
}

function* requestLoginUserMaster({ payload }) {
	const { body } = payload;

	try {
		if (typeof body === 'string') {
			var dadosMobile = '';
			var data = '';
			data = {
				access: body,
				refresh: body
			};
			dadosMobile = jwtDecode(body).sub;

			yield put(
				successLogin({
					...data,
					dados: dadosMobile,
				})
			);

			handleLoginSuccessGA4(dadosMobile)

			if (!dadosMobile.permissoes.view_dashboard) {
				history.push(`/client/transacoes`);
			} else if (dadosMobile.permissoes.view_dashboard) {
				history.push(`/client/dashboard`);
			} else if (
				dadosMobile.tipo_perfil.toLowerCase() === 'cliente' ||
				dadosMobile.tipo_perfil.toLowerCase() === 'operador' ||
				dadosMobile.tipo_perfil.toLowerCase() === ''
			) {
				apiGatewayPagamentos.defaults.headers.Authorization = `Basic ${dadosMobile.gateway_token}`;
				history.push(`/client/dashboard`);
			}
		} else {
			const resposta = yield call(
				apiLucree.post,
				'/authentication/api/token/impersonate',
				body
			);



			const dados = jwtDecode(resposta.data.access).sub;
			yield put(
				successLogin({
					...resposta.data,
					dados,
				})
			);

			handleLoginSuccessGA4(dados)

			if (!dados.permissoes.view_dashboard) {
				history.push(`/client/transacoes`);
			} else if (dados.permissoes.view_dashboard) {
				history.push(`/client/dashboard`);
			} else if (
				dados.tipo_perfil.toLowerCase() === 'cliente' ||
				dados.tipo_perfil.toLowerCase() === 'operador' ||
				dados.tipo_perfil.toLowerCase() === ''
			) {
				apiGatewayPagamentos.defaults.headers.Authorization = `Basic ${dados.gateway_token}`;
				history.push(`/client/dashboard`);
			}
		}
	} catch (error) {
		yield put(
			failureLogin(error.response ? error.response.status : 'CORS')
		);
		toast.error(
			`Erro: ${error.response ? error.response.status : 'CORS'
			} - ${error?.response?.data?.error || 'Revise seu usuário ou senha e tente novamente'} `
		);

		handleErrorLoginGA4(error)
	}
}

function* requestResetPass({ payload }) {
	const { body } = payload;
	try {
		yield call(
			apiLucree.post,
			'/authentication/api/email/reset-password',
			body
		);

		toast.success(
			'Enviamos um e-mail com as orientações para criar uma nova senha'
		);
	} catch (error) {
		toast.error(
			`${error.response.status}: Por favor, verifique se o e-mail está correto`
		);
	}
}

function* requestAlterarSenha({ payload }) {
	const { body } = payload;

	try {
		yield call(apiLucree.put, '/authentication/api/password', body);

		toast.success('Senha alterada com sucesso');
	} catch (error) {
		toast.error(`${error.response.status}: Oops algo deu errado`);
	}
}

function* requestAlterarSenhaToken({ payload }) {
	const { body } = payload;
	try {
		yield call(
			apiLucree.patch,
			'/authentication/api/email/reset-password',
			body
		);

		toast.success('Senha alterada com sucesso');
	} catch (error) {
		toast.error(`${error.response.status}: Oops algo deu errado`);
	}
}

function* setTokenUser({ payload }) {
	if (!payload) return;

	const { user } = payload.auth;

	if (user.token !== null) {
		if (jwtDecode(user.token.access).exp < Date.now() / 1000) {
			yield put(signOut());
		} else {
			apiGatewayPagamentos.defaults.headers.Authorization = `Basic ${user.dados.gateway_token}`;
			history.push(history.location.pathname);
		}
	} else {
		history.push(history.location.pathname);
	}
}

function* getTokenDev() {
	try {
		const responseApiToken = yield call(apiToken.get, '/', {});
		apiHierarquia.defaults.headers.Authorization = `${responseApiToken.data.id_token}`;
		apiLucree.defaults.headers.Authorization = `${responseApiToken.data.id_token}`;
		apiComercial.defaults.headers.Authorization = `${responseApiToken.data.id_token}`;
		apiLiquidacao.defaults.headers.Authorization = `${responseApiToken.data.id_token}`;
		apiTransacao.defaults.headers.Authorization = `${responseApiToken.data.id_token}`;

		yield put(successTokenDev(responseApiToken.data.id_token));
	} catch (error) {
		yield put(failureTokenDev(error.response.data.status));
	}
}

function* setTokenDev({ payload }) {
	if (!payload) return;

	const { dev } = payload.auth;

	try {
		if (jwtDecode(dev.token).exp < Date.now() / 1000) {
			const responseApiToken = yield call(apiToken.get, '/', {});
			apiHierarquia.defaults.headers.Authorization = `${responseApiToken.data.id_token}`;
			apiLucree.defaults.headers.Authorization = `${responseApiToken.data.id_token}`;
			apiComercial.defaults.headers.Authorization = `${responseApiToken.data.id_token}`;
			apiLiquidacao.defaults.headers.Authorization = `${responseApiToken.data.id_token}`;
			apiTransacao.defaults.headers.Authorization = `${responseApiToken.data.id_token}`;

			yield put(successTokenDev(responseApiToken.data.id_token));
			yield delay(3000);
			history.push(history.location.pathname);
		} else {
			apiHierarquia.defaults.headers.Authorization = dev.token;
			apiLucree.defaults.headers.Authorization = dev.token;
			apiComercial.defaults.headers.Authorization = dev.token;
			apiLiquidacao.defaults.headers.Authorization = dev.token;
			apiTransacao.defaults.headers.Authorization = dev.token;

			yield put(successTokenDev(dev.token));
		}
	} catch (error) {
		const responseApiToken = yield call(apiToken.get, '/', {});
		apiHierarquia.defaults.headers.Authorization = `${responseApiToken.data.id_token}`;
		apiLucree.defaults.headers.Authorization = `${responseApiToken.data.id_token}`;
		apiComercial.defaults.headers.Authorization = `${responseApiToken.data.id_token}`;
		apiLiquidacao.defaults.headers.Authorization = `${responseApiToken.data.id_token}`;
		apiTransacao.defaults.headers.Authorization = `${responseApiToken.data.id_token}`;

		yield put(successTokenDev(responseApiToken.data.id_token));
		yield delay(3000);
		history.push(history.location.pathname);
	}
}

function requestSignOut(action = {}) {
	const isImpersonated = action?.payload?.user?.dados?.is_impersonated || false;
	if(isImpersonated){
		history.push('/auth/master/login');
	}else{
		history.push('/auth/login');
	}
}


export default all([
	takeLatest('persist/REHYDRATE', setTokenDev),
	takeLatest('persist/REHYDRATE', setTokenUser),
	// takeLatest('persist/REHYDRATE', requestTokenDev),
	takeLatest('@auth/REQUEST_LOGIN', requestLoginUser),
	takeLatest('@auth/REQUEST_LOGIN_MASTER', requestLoginUserMaster),
	takeLatest('@auth/SUCCESS_LOGIN', getTokenDev),
	takeLatest('@auth/REQUEST_TOKEN_DEV', getTokenDev),
	takeLatest('@auth/REQUEST_RESETPASS', requestResetPass),
	takeLatest('@auth/REQUEST_ALTERAR_SENHA', requestAlterarSenha),
	takeLatest('@auth/REQUEST_ALTERAR_SENHA_TOKEN', requestAlterarSenhaToken),
	takeLatest('@auth/SIGNOUT', requestSignOut),
]);
